export default "__VITE_ASSET__5a30262c__"